import { advice, postAdvice, putAdvice, allAdvices } from '@/services/dashboard.service';

export default {
	namespaced: true,
	state: {
        appointment: [],
        exams: [],
        vaccines: [],
        appointmentAll: [],
        examsAll: [],
        vaccinesAll: [],
		// STATUS
        appointmentStatus: 'init',
        examStatus: 'init',
        vaccineStatus: 'init',
		alert: {
			show: false,
			message: "",
			variant: ""
		}
	},
	getters: {
        getAppointmentAll(state){
			return state.appointmentAll
		},
        getExamAll(state){
			return state.examsAll
		},
        getVaccineAll(state){
			return state.vaccinesAll
		},
		getAppointment(state){
			return state.appointment
		},
        getExam(state){
			return state.exams
		},
        getVaccine(state){
			return state.vaccines
		},
		// STATUS
        getAppointmentStatus(state){
			return state.appointmentStatus
		},
        getExamStatus(state){
			return state.examStatus
		},
        getVaccineStatus(state){
			return state.vaccineStatus
		},
		getAlerts(state){
			return state.alert
		}
	},
	mutations: {
        SET_APPOINTMENT(state, value) {
			state.appointment = value;
		},
        SET_EXAME(state, value) {
			state.exams = value;
		},
        SET_VACCNIE(state, value) {
			state.vaccines = value;
		},
		SET_APPOINTMENT_ALL(state, value) {
			state.appointmentAll = value;
		},
        SET_EXAME_ALL(state, value) {
			state.examsAll = value;
		},
        SET_VACCNIE_ALL(state, value) {
			state.vaccinesAll = value;
		},
		// STATUS
        APPOINTMENT_STATUS(state, value) {
			state.appointmentStatus = value;
		},
        EXAME_STATUS(state, value) {
			state.examStatus = value;
		},
        VACCNIE_STATUS(state, value) {
			state.vaccineStatus = value;
		},
		// ALERT
		SET_ALERT(state, value) {
			console.log(value)
			state.alert = {
				show: value.show,
				message: value.message,
				variant: value.variant
			}
		},
	},
	actions: {
        async getAppointment({ commit }, params) {
			commit('APPOINTMENT_STATUS', 'pending');
			try {
				const { data } = await advice(params)
				commit('APPOINTMENT_STATUS', 'init');
                commit('SET_APPOINTMENT', data.items);
				return data;
			} catch (error) {
				commit('APPOINTMENT_STATUS', 'init');
				throw error
			}
		},
        async getExams({ commit }, params) {
			commit('EXAME_STATUS', 'pending');
			try {
				const { data } = await advice(params)
				commit('EXAME_STATUS', 'init');
                commit('SET_EXAME', data.items);
				return data;
			} catch (error) {
				commit('EXAME_STATUS', 'init');
				throw error
			}
		},
		async getVaccines({ commit }, params) {
			commit('VACCNIE_STATUS', 'pending');
			try {
				const { data } = await advice(params)
				commit('VACCNIE_STATUS', 'init');
                commit('SET_VACCNIE', data.items);
				return data;
			} catch (error) {
				commit('VACCNIE_STATUS', 'init');
				throw error
			}
		},
		async setAdviceVaccine({ commit }, params) {
			commit('VACCNIE_STATUS', 'pending');
			try {
				const { data } = await postAdvice(params)
				commit('VACCNIE_STATUS', 'init');
                //commit('SET_VACCNIE', data.item);
				return data;
			} catch (error) {
				commit('VACCNIE_STATUS', 'init');
				throw error
			}
		},
		async unSetAdviceVaccine({ commit }, params) {
			commit('VACCNIE_STATUS', 'pending');
			try {
				const { data } = await putAdvice(params)
				commit('VACCNIE_STATUS', 'init');
                //commit('SET_VACCNIE', data.item);
				return data;
			} catch (error) {
				commit('VACCNIE_STATUS', 'init');
				throw error
			}
		},
		async setAdviceExam({ commit }, params) {
			commit('EXAME_STATUS', 'pending');
			try {
				const { data } = await postAdvice(params)
				commit('EXAME_STATUS', 'init');
                //commit('SET_VACCNIE', data.item);
				return data;
			} catch (error) {
				commit('EXAME_STATUS', 'init');
				throw error
			}
		},
		async unSetAdviceExam({ commit }, params) {
			commit('EXAME_STATUS', 'pending');
			try {
				const { data } = await putAdvice(params)
				commit('EXAME_STATUS', 'init');
                //commit('SET_VACCNIE', data.item);
				return data;
			} catch (error) {
				commit('EXAME_STATUS', 'init');
				throw error
			}
		},
		async getAppointmentAll({ commit }, params) {
			commit('APPOINTMENT_STATUS', 'pending');
			try {
				const { data } = await allAdvices(params)
				commit('APPOINTMENT_STATUS', 'init');
                commit('SET_APPOINTMENT_ALL', data.items);
				return data;
			} catch (error) {
				commit('APPOINTMENT_STATUS', 'init');
				throw error
			}
		},
        async getExamsAll({ commit }, params) {
			commit('EXAME_STATUS', 'pending');
			try {
				const { data } = await allAdvices(params)
				commit('EXAME_STATUS', 'init');
                commit('SET_EXAME_ALL', data.items);
				return data;
			} catch (error) {
				commit('EXAME_STATUS', 'init');
				throw error
			}
		},
		async getVaccinesAll({ commit }, params) {
			commit('VACCNIE_STATUS', 'pending');
			try {
				const { data } = await allAdvices(params)
				commit('VACCNIE_STATUS', 'init');
                commit('SET_VACCNIE_ALL', data.items);
				return data;
			} catch (error) {
				commit('VACCNIE_STATUS', 'init');
				throw error
			}
		},
	},
}
